module.exports = __webpack_public_path__ + "static/media/Bath6.9554564a.jpg";